import React from 'react'
import Navbar from './components/Navbar'


export default function Header
() {

  return (
    <>
    <Navbar/>
    </>
  )
}
